enum MemberRole {
  OWNER = 0,
  ADMIN = 1,
  MODERATOR = 2,
  MEMBER = 3,
}

type GroupChatMember = {
  username: string;
  chat_id: string;
  role: MemberRole;
  secure_payload: string;
  profile_image: string;
  public_keys?: string;
  pinned_epoch_payloads?: Record<number, string>; // epoch → new member's eCSK for pinned epochs (§11.10)
};

type SearchMembersPayload = {
  searchTerm: string;
  // contactee?: string;
  // not_contactee?: string;
  member?: string; // pass chatId - gets members INSIDE that chat
  not_member?: string; // pass chatId - gets members OUTSIDE that chat
  offset?: number;
  count?: number;
};

type GetMembersByChatIdPayload = {
  chat_id: string;
  skip?: number;
  take?: number;
};

type MemberFromPrefixSearch = {
  profile_image: string;
  username: string;
  role: MemberRole;
};

type Member = {
  username: string;
  chat_id: string;
  role: MemberRole;
  secure_payload: string;
  profile_image: string; // ??
  thumbnail: string; // ??
  is_contact: boolean;
  public_keys: string;
};

type DeleteMemberPayload = {
  username: string;
  chat_id: string;
};

type UpdateMemberPayload = {
  username: string;
  chat_id: string;
  role: MemberRole;
  secure_payload: string;
  profile_image: string;
};

type MemberOwnershipPayload = {
  to: string;
  chat_id: string;
};

// types
export type {
  GroupChatMember,
  SearchMembersPayload,
  MemberFromPrefixSearch, // updated type name
  GetMembersByChatIdPayload,
  Member,
  DeleteMemberPayload,
  UpdateMemberPayload,
  MemberOwnershipPayload,
};

// enums
export { MemberRole };
